import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createCostingType(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/costing_types', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCostingType(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/costing_types/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCostingTypes(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/costing_types', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidCostingType(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/costing_types/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}